import preact from 'preact'

var editors = {}
export default class extends preact.Component {
  componentDidMount () {
    require.ensure([], (require) => {
      var WysiwygEditor = require('@insided/editor-wysiwyg')
      editors[this.props.id] = new WysiwygEditor(this.props.options)
    }, 'wysiwyg-editor')
  }

  render (props) {
    return (
      <div id={props.id} className='wysiwyg-editor__textarea' />
    )
  }
}

export function returnContent (id) {
  return editors[id] ? editors[id].getDialectContent() : null
}
